import { useEffect } from 'react';
import { DeclarativeModal } from 'seagull';
import { useStateFromUrl } from 'seagull/utils/useStateFromUrl';
import { useInvoiceChangesObservable } from "../../providers/InvoiceChangesObservableProvider";
import FullPageInvoice from "./FullPageInvoice";
import { invoiceSearchParam, relationshipSearchParam } from "./FullPageInvoice.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export default function FullPageInvoiceOpener(props) {
  const {
    urlState: {
      invoice,
      relationship
    },
    changeUrlState
  } = useStateFromUrl({
    [invoiceSearchParam]: {
      defaultValue: ''
    },
    [relationshipSearchParam]: {
      defaultValue: ''
    }
  });
  const {
    notify
  } = useInvoiceChangesObservable();
  useEffect(() => {
    if (invoice && !relationship) {
      changeUrlState({
        invoice: ''
      });
    } else if (!invoice && relationship) {
      changeUrlState({
        relationship: ''
      });
    }
  }, [invoice, relationship]);
  const content = _ref => {
    let {
      dismissModal
    } = _ref;
    return /*#__PURE__*/_jsx(FullPageInvoice, {
      invoiceId: invoice,
      relationshipId: relationship,
      dismissModal: dismissModal,
      onRefresh: notify
    });
  };
  return /*#__PURE__*/_jsx(DeclarativeModal, {
    isOpen: !!(invoice && relationship),
    content: props.content || content,
    onClose: () => {
      changeUrlState({
        invoice: '',
        relationship: ''
      }, {
        push: true
      });
    }
  });
}